export default [
  // {path: '/hometest', name: 'home', component: () => import('@/view/home/home'), meta: {title: '联系我们', },},
  {path: '/', name: 'hometest', component: () => import('@/view/hometest/hometest'), meta: {title: '首页', }, },
  {path: '/search/:html', name: '防伪查询', component: () => import('@/view/search/search'), meta: {title: '防伪查询', }, },
  {path: '/productList/:page/:html', name: '全线产品', component: () => import('@/view/productList/productList'), meta: {title: '全线产品', }, },
  {path: '/aboutProducts/:html', name: '关于产品', component: () => import('@/view/aboutProducts/aboutProducts'), meta: {title: '关于产品', }, },
  {path: '/productInfo/:id/:html', name: '产品详情', component: () => import('@/view/productInfo/productInfo'), meta: {title: '产品详情', }, },
  {path: '/zmlSuggest', name: '脂枚乐', component: () => import('@/view/zmlApp/zmlAppSuggest'), meta: {title: '投诉建议', }, },
  {path: '/suggestList', name: '脂枚乐投诉列表', component: () => import('@/view/zmlApp/suggestList'), meta: {title: '投诉建议', }, },
  {path: '/suggestDetail', name: '脂枚乐投诉详情', component: () => import('@/view/zmlApp/suggestDetail'), meta: {title: '投诉建议', }, },
];



// WEBPACK FOOTER //
// src/router/home.js